import { render } from "./whatsappBusiness.vue?vue&type=template&id=426c3151"
import script from "./whatsappBusiness.vue?vue&type=script&lang=js"
export * from "./whatsappBusiness.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__